/* Page collection V3 (13/10/2026) : filtres sans rechargement (rendu de section Shopify), « Voir plus » 24 par 24,
   barre de filtres collée sous l'en-tête, panier + sur téléphone avec choix de la variante. Aucune dépendance. */
(function () {
  'use strict';
  var PAS = 24;
  var reduit = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cache = new Map();
  var racine = function () { return document.querySelector('[data-bz-col]'); };
  var $ = function (s, r) { return (r || racine() || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || racine() || document).querySelectorAll(s)); };
  if (!racine()) return;
  // 17/10 (traductions) : textes dans la langue de la page (bloc data-bz-col-textes de bz-v3-collection), français par défaut
  var TX = {};
  try { TX = JSON.parse((document.querySelector('[data-bz-col-textes]') || {}).textContent || '{}'); } catch (e) {}
  function tx(k, fr) { return TX[k] || fr; }
  document.documentElement.classList.add('bz-col-page');
  // téléphone : la pastille de la famille choisie est ramenée au centre de sa rangée
  function centrerPastille() {
    var a = $('.bz-col-pastille[aria-current]'); if (!a) return;
    var rang = a.parentElement; rang.scrollLeft = a.offsetLeft - (rang.clientWidth - a.offsetWidth) / 2;
  }
  centrerPastille();

  /* ---------- barre collée sous l'en-tête (l'en-tête réapparaît quand on remonte) ---------- */
  var tete = document.querySelector('.section-header');
  function majHaut() {
    var b = 0;
    // bas de la bande visible (en-tête compact sur ordinateur : la section garde sa hauteur, seule la bande .header-wrapper est visible)
    if (tete) { var r = (tete.querySelector('.header-wrapper') || tete).getBoundingClientRect(); b = Math.max(0, Math.round(r.bottom)); }
    document.documentElement.style.setProperty('--bz-col-haut', b + 'px');
    var barre = $('[data-bz-barre]');
    if (barre) barre.classList.toggle('est-collee', barre.getBoundingClientRect().top <= b + 1);
  }
  var tic = false;
  addEventListener('scroll', function () {
    if (tic) return; tic = true;
    requestAnimationFrame(function () { majHaut(); tic = false; });
    clearTimeout(majHaut.t); majHaut.t = setTimeout(majHaut, 450);
  }, { passive: true });
  // 17/10 (juge) : l'en-tête glisse en 0,38 s quand il revient (0,25 s quand il repart) ; la barre le suit image par image pendant le glissement
  var suivi = 0;
  function suivreEntete() {
    var fin = Date.now() + 450; cancelAnimationFrame(suivi);
    (function boucle() { majHaut(); if (Date.now() < fin) suivi = requestAnimationFrame(boucle); })();
  }
  var classeTete = tete ? tete.className : '';
  if (tete && 'MutationObserver' in window) new MutationObserver(function () {
    if (tete.className === classeTete) return; // le thème réécrit souvent la même classe : seulement les vrais changements
    classeTete = tete.className; suivreEntete();
  }).observe(tete, { attributes: true, attributeFilter: ['class'] });
  addEventListener('resize', majHaut); majHaut();

  /* ---------- chargement d'une URL de collection (section seule) ---------- */
  function urlSection(url) {
    var u = new URL(url, location.origin);
    u.searchParams.set('section_id', racine().dataset.section);
    return u.toString();
  }
  function recup(url) {
    var k = urlSection(url);
    if (cache.has(k)) return Promise.resolve(cache.get(k));
    return fetch(k, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (t) {
      var d = new DOMParser().parseFromString(t, 'text/html').querySelector('[data-bz-col]');
      if (!d) throw new Error('section absente');
      cache.set(k, d); return d;
    });
  }
  function remplacer(d) {
    var r = racine();
    r.innerHTML = d.cloneNode(true).innerHTML;
    r.dataset.suivant = d.dataset.suivant || '';
    if (window.WishListHero && typeof window.WishListHero.reload === 'function') { try { window.WishListHero.reload(); } catch (e) {} }
  }
  function aller(url, pousser) {
    var r = racine();
    r.setAttribute('aria-busy', 'true');
    return recup(url).then(function (d) {
      fermer(true);
      remplacer(d);
      centrerPastille();
      if (pousser !== false) history.pushState({ bzCol: 1 }, '', url);
      var barre = $('[data-bz-barre]'), haut = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--bz-col-haut'), 10) || 0;
      if (barre && barre.getBoundingClientRect().top < haut) {
        var y = barre.getBoundingClientRect().top + scrollY - haut;
        window.scrollTo({ top: y, behavior: reduit ? 'auto' : 'smooth' });
      }
      majHaut();
    }).catch(function () { location.assign(url); }).finally(function () { r.removeAttribute('aria-busy'); });
  }
  // après le choix d'une famille : on descend jusqu'à la barre de filtres, les produits juste dessous
  function allerAuxProduits() {
    var barre = $('[data-bz-barre]'); if (!barre) return;
    var haut = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--bz-col-haut'), 10) || 0;
    var y = barre.getBoundingClientRect().top + scrollY - haut;
    if (Math.abs(y - scrollY) > 4) window.scrollTo({ top: y, behavior: reduit ? 'auto' : 'smooth' });
  }
  addEventListener('popstate', function () { if (racine()) aller(location.href, false); });

  /* ---------- tiroir « Filtrer et trier » ---------- */
  var retour = null;
  function ouvrir(cle) {
    retour = document.activeElement;
    var msg = $('[data-bz-message]'); if (msg) msg.classList.remove('vu');
    $('[data-bz-voile], .bz-col-voile').hidden = false;
    var t = $('[data-bz-tiroir]'); t.hidden = false;
    $$('.bz-col-acc', t).forEach(function (a) {
      var on = a.dataset.acc === cle; a.classList.toggle('ouvert', on);
      a.firstElementChild.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
    document.documentElement.style.overflow = 'hidden'; document.documentElement.classList.add('bz-col-modal');
    setTimeout(function () { var x = $('.bz-col-x', t); if (x) x.focus(); }, reduit ? 0 : 300);
    apercu();
  }
  function fermer(silence) {
    var t = $('[data-bz-tiroir]'), f = $('[data-bz-feuille]');
    var etait = (t && !t.hidden) || (f && !f.hidden);
    if (t) t.hidden = true; if (f) f.hidden = true;
    var v = $('.bz-col-voile'); if (v) v.hidden = true;
    document.documentElement.style.overflow = ''; document.documentElement.classList.remove('bz-col-modal');
    if (etait && !silence && retour && retour.isConnected && retour.focus) retour.focus();
  }
  function urlFormulaire() {
    var f = $('[data-bz-form]'), p = new URLSearchParams();
    $$('input[data-types]:checked', f).forEach(function (i) { JSON.parse(i.dataset.types).forEach(function (t) { p.append('filter.p.product_type', t); }); });
    $$('input[data-param]:checked', f).forEach(function (i) { p.append(i.name, i.value); });
    var pr = $('input[name="bz-prix"]:checked', f);
    if (pr && pr.value) { var ab = pr.value.split('-'); if (ab[0]) p.set('filter.v.price.gte', ab[0]); if (ab[1]) p.set('filter.v.price.lte', ab[1]); }
    var tri = $('input[name="sort_by"]:checked', f);
    if (tri && tri.value !== f.dataset.triDefaut) p.set('sort_by', tri.value);
    var q = p.toString();
    return f.dataset.base + (q ? '?' + q : '');
  }
  var attente;
  function apercu() {
    var bouton = $('[data-bz-voir]'); if (!bouton) return;
    clearTimeout(attente);
    bouton.classList.add('charge');
    attente = setTimeout(function () {
      var url = urlFormulaire();
      recup(url).then(function (d) {
        if (urlFormulaire() !== url) return;
        var n = +(d.querySelector('[data-bz-total]') || {}).dataset.n || 0;
        var tot = d.querySelector('[data-bz-total]') || {}, txt = (tot.dataset && tot.dataset.min) || tot.textContent || '';
        bouton.textContent = n ? (bouton.dataset.voir || 'Voir les [T]').replace('[T]', txt.trim()) : (bouton.dataset.aucun || 'Aucune pièce');
        bouton.disabled = !n;
      }).catch(function () {}).finally(function () { bouton.classList.remove('charge'); });
    }, 220);
  }

  /* ---------- « Voir plus » ---------- */
  function majPlus() {
    var r = racine(), toutes = $$('.bz-col-carte'), vues = toutes.filter(function (c) { return !c.hidden; }).length;
    var zone = $('[data-bz-plus-zone]'); if (!zone) return;
    var total = +($('[data-bz-total]') || {}).dataset.n || toutes.length;
    var nb = $('[data-bz-vues]', zone); if (nb) nb.textContent = vues;
    var j = $('[data-bz-jauge]', zone); if (j) j.style.width = Math.min(100, Math.round(vues / Math.max(total, 1) * 100)) + '%';
    var reste = toutes.length > vues || !!r.dataset.suivant;
    $('[data-bz-plus]', zone).hidden = !reste;
  }
  function plus() {
    var cachees = $$('.bz-col-carte[hidden]');
    cachees.slice(0, PAS).forEach(function (c) { c.hidden = false; });
    var r = racine();
    if (cachees.length <= PAS && r.dataset.suivant) {
      var b = $('[data-bz-plus]'); b.disabled = true;
      recup(r.dataset.suivant).then(function (d) {
        var g = $('[data-bz-grille]');
        Array.prototype.slice.call(d.querySelectorAll('.bz-col-carte')).forEach(function (c, k) {
          var n = c.cloneNode(true); n.hidden = k >= PAS - cachees.length; g.appendChild(n);
        });
        r.dataset.suivant = d.dataset.suivant || '';
      }).catch(function () {}).finally(function () { b.disabled = false; majPlus(); });
    }
    majPlus();
  }

  /* ---------- message en bas d'écran ---------- */
  var tm;
  function message(txt, panier) {
    var m = $('[data-bz-message]'); if (!m) return;
    m.querySelector('span').textContent = txt;
    m.querySelector('[data-bz-voir-panier]').hidden = !panier;
    m.classList.add('vu'); clearTimeout(tm);
    tm = setTimeout(function () { m.classList.remove('vu'); }, 4200);
  }

  /* ---------- panier + (téléphone) ---------- */
  var enCours = null, choix = [];
  function euros(c) { var s = (c / 100).toFixed(2).replace('.', ','); return (s.slice(-3) === ',00' ? s.slice(0, -3) : s) + ' €'; }
  function dispo(info) { return info.v.filter(function (v) { return v[2]; }); }
  function variante() { return dispo(enCours).find(function (v) { return v[1].every(function (x, k) { return x === choix[k]; }); }); }
  function majFeuille() {
    var f = $('[data-bz-feuille]'), v = variante(), vs = dispo(enCours);
    $$('.bz-col-groupe', f).forEach(function (g, k) {
      $$('button', g).forEach(function (bt) {
        var essai = choix.slice(); essai[k] = bt.dataset.v;
        var possible = vs.some(function (w) { return w[1].every(function (x, j) { return essai[j] == null || x === essai[j]; }); });
        bt.disabled = !possible;
        bt.setAttribute('aria-pressed', choix[k] === bt.dataset.v ? 'true' : 'false');
      });
    });
    $('[data-bz-feuille-ok]', f).disabled = !v;
    if (v) $('[data-bz-feuille-prix]', f).textContent = euros(v[3]);
  }
  function ouvrirFeuille(carte, info) {
    enCours = info; retour = document.activeElement;
    var vs = dispo(info);
    choix = info.o.map(function (o, k) {
      var vals = vs.map(function (v) { return v[1][k]; }).filter(function (x, i, a) { return a.indexOf(x) === i; });
      return vals.length === 1 ? vals[0] : null;
    });
    var f = $('[data-bz-feuille]');
    var img = carte.querySelector('.i1'); var fi = f.querySelector('img');
    if (img) { fi.src = img.currentSrc || img.src; } fi.alt = '';
    f.querySelector('h3').textContent = info.t;
    $('[data-bz-feuille-prix]', f).innerHTML = carte.querySelector('.bz-col-prix').innerHTML;
    var zone = $('[data-bz-feuille-choix]', f); zone.innerHTML = '';
    info.o.forEach(function (nom, k) {
      var vals = vs.map(function (v) { return v[1][k]; }).filter(function (x, i, a) { return a.indexOf(x) === i; });
      var g = document.createElement('div'); g.className = 'bz-col-groupe';
      var p = document.createElement('p'); p.textContent = tx('choisir', 'Choisir : ') + nom.toLowerCase(); g.appendChild(p);
      var l = document.createElement('div'); l.className = 'bz-col-vals'; l.setAttribute('role', 'group'); l.setAttribute('aria-label', nom);
      vals.forEach(function (val) {
        var b = document.createElement('button'); b.type = 'button'; b.textContent = val; b.dataset.v = val;
        b.addEventListener('click', function () { choix[k] = choix[k] === val ? null : val; majFeuille(); });
        l.appendChild(b);
      });
      g.appendChild(l); zone.appendChild(g);
    });
    majFeuille();
    $('.bz-col-voile').hidden = false; f.hidden = false; document.documentElement.classList.add('bz-col-modal');
    setTimeout(function () { var b = zone.querySelector('button:not([disabled])'); if (b) b.focus(); }, reduit ? 0 : 300);
  }
  function ajouter(id, libelle) {
    var corps = { items: [{ id: id, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname };
    var racineShop = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(racineShop + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(corps) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (x) {
        if (!x.ok || x.j.status) { message(x.j.description || tx('erreur_ajout', 'Cette pièce n\'a pas pu être ajoutée.'), false); return; }
        var sec = x.j.sections || {}, P = new DOMParser();
        if (sec['cart-icon-bubble']) {
          var bulle = document.getElementById('cart-icon-bubble'), nb = P.parseFromString(sec['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (bulle && nb) bulle.innerHTML = nb.innerHTML;
        }
        if (sec['cart-drawer']) {
          var cd = document.getElementById('CartDrawer'), nd = P.parseFromString(sec['cart-drawer'], 'text/html').querySelector('#CartDrawer');
          if (cd && nd) cd.innerHTML = nd.innerHTML;
          var el = document.querySelector('cart-drawer');
          if (el) { el.classList.remove('is-empty'); var inner = el.querySelector('.drawer__inner'); if (inner) inner.classList.remove('is-empty'); }
        }
        message(tx('ajoute', 'Ajouté au panier : ') + libelle, true);
      })
      .catch(function () { message(tx('connexion', 'Connexion perdue : réessayez.'), false); });
  }

  /* ---------- écouteurs (délégation : le contenu est remplacé à chaque filtre) ---------- */
  document.addEventListener('click', function (e) {
    var r = racine(); if (!r || !r.contains(e.target)) return;
    var t = e.target.closest('a[data-bz-nav]');
    if (t && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      e.preventDefault();
      var famille = t.matches('.bz-col-tuile, .bz-col-pastille');
      aller(t.href).then(function () { if (famille) allerAuxProduits(); });
      return;
    }
    t = e.target.closest('[data-bz-ouvre]'); if (t) { ouvrir(t.dataset.bzOuvre); return; }
    t = e.target.closest('[data-bz-fermer]'); if (t) { fermer(); return; }
    t = e.target.closest('.bz-col-acc>button');
    if (t) { var a = t.parentElement; a.classList.toggle('ouvert'); t.setAttribute('aria-expanded', a.classList.contains('ouvert') ? 'true' : 'false'); return; }
    if (e.target.closest('[data-bz-voir]')) { aller(urlFormulaire()).then(allerAuxProduits); return; }
    if (e.target.closest('[data-bz-effacer]')) {
      var f = $('[data-bz-form]');
      $$('input[type=checkbox]', f).forEach(function (i) { i.checked = false; });
      var tous = $('input[name="bz-prix"][value=""]', f); if (tous) tous.checked = true;
      apercu(); return;
    }
    if (e.target.closest('[data-bz-plus]')) { plus(); return; }
    t = e.target.closest('[data-bz-ajout]');
    if (t) {
      var carte = t.closest('.bz-col-carte'), info = JSON.parse(carte.querySelector('[data-bz-v]').textContent), vs = dispo(info);
      if (!vs.length) return;
      if (info.d || vs.length === 1) { t.disabled = true; ajouter(vs[0][0], info.t + (info.d ? '' : ' · ' + vs[0][1].join(' · '))).finally(function () { t.disabled = false; }); }
      else ouvrirFeuille(carte, info);
      return;
    }
    if (e.target.closest('[data-bz-feuille-ok]')) {
      var v = variante(); if (!v) return;
      var lib = enCours.t + ' · ' + v[1].join(' · ');
      fermer(); ajouter(v[0], lib); return;
    }
    if (e.target.closest('[data-bz-voir-panier]')) {
      var cdr = document.querySelector('cart-drawer');
      if (cdr && typeof cdr.open === 'function') cdr.open(); else location.assign('/cart');
      $('[data-bz-message]').classList.remove('vu');
    }
  });
  document.addEventListener('change', function (e) {
    var r = racine(); if (!r || !e.target.closest('[data-bz-form]')) return;
    apercu();
  });
  document.addEventListener('keydown', function (e) {
    var r = racine(); if (!r) return;
    var t = $('[data-bz-tiroir]'), f = $('[data-bz-feuille]');
    var boite = t && !t.hidden ? t : f && !f.hidden ? f : null;
    if (!boite) return;
    if (e.key === 'Escape') { fermer(); return; }
    if (e.key !== 'Tab') return;
    var el = $$('button:not([disabled]), input:not([disabled]), a[href]', boite).filter(function (x) { return x.offsetParent !== null; });
    if (!el.length) return;
    var a = el[0], z = el[el.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  });
})();
